import { ElementType } from 'react';
import { FormBuilderProps } from '../../types';
import { PageBuilderProps } from './PageBuilder';

type BuilderFields = 'Form' | 'Page';

const Builder: {
  Form?: ElementType<FormBuilderProps>;
  Page?: ElementType<PageBuilderProps>;
} = {};

export default Builder;

export const registerBuilder = (id: BuilderFields, builder: any) => {
  Builder[id] = builder;
};
